import React from 'react';
import PropTypes from 'prop-types';

export default class TemplateWrapper extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = { container: React.createRef() };
    }

    static get propTypes() {

        return {
            selector: PropTypes.string.isRequired,
        };
    }

    render() {

        /** get reference raw html code */
        const reference = document.body
            .querySelector(this.props.selector)
            ?.content
            ?.firstElementChild
            .outerHTML;

        return (
            <div
                ref={ this.nodes.container }
                dangerouslySetInnerHTML={{ __html: reference }}
                { ...this.unusedProps } />
        );
    }

    componentDidMount() {

        if (this.alreadyUpdated)
            return;
        
        this.alreadyUpdated = true;

        /** manual script loading and executing */
        const tasks = Array
            .from(this.nodes.container.current.querySelectorAll('script'))
            .map((el) => {

                /** return FUNCTION (!) which creates a promise */
                return () => new Promise((resolve) => {

                    if (el.parentNode != undefined) {

                        const { src, innerHTML } = el;

                        if (src != '') {
    
                            const script = document.createElement('script');
                            script.src = src;
                            script.onload = () => resolve();
                            el.parentElement.replaceChild(script, el);
                        }
                        else {

                            eval(innerHTML);
                            resolve();
                        }
                    }
                });

            });

        /** sync execution scripts */
        this.promiseAllSync(tasks);
    }

    componentWillUnmount() {

        this.alreadyUpdated = false;
    }

    promiseAllSync(tasks) {

        /** recursion with array reduction */
        if (tasks.length != 0)
            (tasks.shift())().then(() => this.promiseAllSync(tasks));
    }

    /** private */ get unusedProps() {
        
        const usedKeys = Object.keys(TemplateWrapper.propTypes);
        return Object.fromEntries(Object.entries(this.props).map(([key, value]) => {
            
            if (!usedKeys.includes(key))
                return [key, value];

        }).filter((value) => value !== undefined));
    }

}